import { FC, useState } from 'react';
import { CollapseProps } from './interface';
import { Collapse } from '@arco-design/mobile-react';
import { showText } from '@shared/assets/svg/base';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import styles from './index.module.less';

const mobile: FC<CollapseProps> = ({ data }) => {
	const [open, setOpen] = useState(new Array(data.length).fill(false));
	return (
		<Collapse.Group className={styles.mobile}>
			{data.map((item, index) => (
				<Collapse
					header={item.title}
					icon={
						<NewBaseIcon
							size={24}
							icon={showText}
							style={{
								transform: `rotate(${open[Number(index)] ? '180deg' : '0deg'})`,
								transition: 'transform .3s',
							}}
						/>
					}
					value={index.toString()}
					key={index}
					content={item.content}
					onCollapse={(_key) => {
						const key = Number(_key);
						open[key] = !open[key];
						setOpen([...open]);
					}}
				/>
			))}
		</Collapse.Group>
	);
};

export default mobile;
